import {
  compose,
  converge,
  propOr,
  prop,
  defaultTo,
  not,
  isEmpty,
} from 'ramda';

import {
  selectedProduct,
  productPlanSku,
} from 'app/features/products/selectors';
import { selectedPlan } from 'app/features/billing/selectors';
import { fromProps } from 'app/selectors/props';

const plans = prop('plans');

const havePlansLoaded = compose(not, isEmpty, plans);

const selectedProductPlanSku = compose(prop('planSku'), selectedProduct);

const planBySelectedProduct = converge(prop, [selectedProductPlanSku, plans]);

const planByPropsProduct = converge(prop, [productPlanSku, plans]);

const planBySku = converge(prop, [fromProps('sku'), plans]);

const planSelector = converge(defaultTo, [planByPropsProduct, selectedPlan]);

const selectedBillingPlanHashes = compose(prop('hashes'), selectedPlan);

const propsProductPlanHashes = compose(prop('hashes'), planByPropsProduct);

const planByProductSku = converge(propOr({}), [productPlanSku, plans]);

const productPrice = compose(prop('price'), planByProductSku);
const productPriceAmount = compose(prop('amount'), productPrice);
const productSavings = compose(propOr(0, 'savings'), productPrice);
const productCurrency = compose(prop('currencyCode'), productPrice);

export {
  havePlansLoaded,
  selectedBillingPlanHashes,
  propsProductPlanHashes,
  planBySelectedProduct,
  selectedProductPlanSku,
  planByPropsProduct,
  planSelector,
  planBySku,
  productPriceAmount,
  productSavings,
  productCurrency,
};
